import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ScreenFullIcon, ScreenNormalIcon } from '@primer/octicons-react';
import { useArtifactUrl } from '../../hooks/useArtifactUrl';
import { ScreenshotModeIcon, SegmentedControl, VideoModeIcon } from '../SegmentedControl';
import { BrowserUrlBar } from './BrowserUrlBar';
import { getMobileSkinInnerRatios, MobileSkinOverlay } from './MobileSkinOverlay';
import { CursorOverlay, cursorPointFor, elementRectFor, ElementRectOverlay } from './CursorOverlay';
import { StatusBar } from './StatusBar';
import styles from './screenshot.module.css';

/** kaneai's view-logs wrench (quoted setup-wrench.svg, 13×13). */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var WrenchIcon = function WrenchIcon() {
  return /*#__PURE__*/_jsx("svg", {
    width: "13",
    height: "13",
    viewBox: "0 0 13 13",
    fill: "none",
    "aria-hidden": "true",
    children: /*#__PURE__*/_jsx("path", {
      d: "M7.57875 3.24799C7.48429 3.34436 7.43138 3.47392 7.43138 3.60886C7.43138 3.7438 7.48429 3.87336 7.57875 3.96973L8.4036 4.79458C8.49997 4.88904 8.62953 4.94195 8.76447 4.94195C8.89941 4.94195 9.02898 4.88904 9.12534 4.79458L10.7266 3.19386C10.8916 3.02786 11.1715 3.08044 11.2334 3.30624C11.3891 3.87275 11.3803 4.4719 11.208 5.03358C11.0356 5.59526 10.7069 6.09625 10.2602 6.47792C9.81355 6.85959 9.26742 7.10615 8.68572 7.18875C8.10403 7.27135 7.51084 7.18658 6.97557 6.94435L2.89772 11.0222C2.69262 11.2272 2.41449 11.3424 2.12449 11.3423C1.8345 11.3423 1.5564 11.227 1.35138 11.022C1.14636 10.8169 1.0312 10.5387 1.03125 10.2487C1.0313 9.95873 1.14654 9.68064 1.35164 9.47561L5.42949 5.39776C5.18727 4.86249 5.1025 4.2693 5.1851 3.68761C5.2677 3.10591 5.51426 2.55978 5.89593 2.1131C6.27759 1.66643 6.77858 1.33769 7.34027 1.16535C7.90195 0.99302 8.5011 0.984218 9.0676 1.13998C9.29341 1.20184 9.34599 1.48126 9.1805 1.64726L7.57875 3.24799Z",
      stroke: "var(--lt-text-secondary)",
      strokeWidth: "0.966622",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};
var NoVideoIcon = function NoVideoIcon() {
  return /*#__PURE__*/_jsx("svg", {
    width: "48",
    height: "48",
    viewBox: "0 0 15.4318 14.25",
    fill: "none",
    "aria-hidden": "true",
    children: /*#__PURE__*/_jsx("path", {
      d: "M10.0795 13.625H5.35227M13.8068 11.2614H1.625C1.07271 11.2614 0.625 10.8137 0.625 10.2614V1.625C0.625 1.07272 1.07271 0.625 1.625 0.625H13.8068C14.3591 0.625 14.8068 1.07271 14.8068 1.625V10.2614C14.8068 10.8137 14.3591 11.2614 13.8068 11.2614ZM6.21591 7.83973V4.04672C6.21591 3.84705 6.43845 3.72795 6.60458 3.83871L9.44934 5.73521C9.59778 5.83417 9.59778 6.05228 9.44934 6.15124L6.60458 8.04775C6.43845 8.1585 6.21591 8.03941 6.21591 7.83973Z",
      stroke: "var(--lt-border-secondary)",
      strokeWidth: "0.6",
      strokeLinecap: "round"
    })
  });
};

/** kaneai's CursorIcon (Hide Cursor button) — quoted; strike line when hidden. */
var CursorButtonIcon = function CursorButtonIcon(_ref) {
  var hidden = _ref.hidden;
  return /*#__PURE__*/_jsxs("svg", {
    width: "17",
    height: "18",
    viewBox: "0 0 17 18",
    fill: "none",
    "aria-hidden": "true",
    children: [/*#__PURE__*/_jsxs("g", {
      filter: "url(#ev_cursor_btn_shadow)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M7.16913 14.6667L5.08161 4.02726L14.6663 9.27879L9.94505 10.6485L7.16913 14.6667Z",
        fill: "var(--lt-text-primary)"
      }), /*#__PURE__*/_jsx("path", {
        d: "M7.16913 14.6667L5.08161 4.02726L14.6663 9.27879L9.94505 10.6485L7.16913 14.6667Z",
        stroke: "white",
        strokeWidth: "0.666667"
      })]
    }), hidden && /*#__PURE__*/_jsx("line", {
      x1: "3",
      y1: "16",
      x2: "15",
      y2: "3",
      stroke: "var(--lt-text-primary)",
      strokeWidth: "1.5",
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsxs("filter", {
        id: "ev_cursor_btn_shadow",
        x: "3.28288",
        y: "2.72689",
        width: "13.5817",
        height: "14.7824",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          "in": "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/_jsx("feOffset", {
          dy: "0.666667"
        }), /*#__PURE__*/_jsx("feGaussianBlur", {
          stdDeviation: "0.666667"
        }), /*#__PURE__*/_jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/_jsx("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow"
        }), /*#__PURE__*/_jsx("feBlend", {
          mode: "normal",
          "in": "SourceGraphic",
          in2: "effect1_dropShadow",
          result: "shape"
        })]
      })
    })]
  });
};
var EmptyStateIcon = function EmptyStateIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    width: "48",
    height: "48",
    viewBox: "0 0 24 24",
    fill: "none",
    "aria-hidden": "true",
    children: [/*#__PURE__*/_jsx("rect", {
      x: "3",
      y: "3",
      width: "18",
      height: "18",
      rx: "2",
      stroke: "var(--lt-border-secondary)",
      strokeWidth: "1.5"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "8.5",
      cy: "8.5",
      r: "1.5",
      fill: "var(--lt-border-secondary)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M21 15L16 10L5 21",
      stroke: "var(--lt-border-secondary)",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};

/* Video ships in a later phase — the toggle is hidden until producers
 * author video (user 2026-07-10). All video code below stays live; flip
 * this to restore the Screenshot/Video segmented control. */
var VIDEO_TOGGLE_ENABLED = false;

/**
 * Port of kaneai's ScreenshotPreviewPanel (toolbar variant): segmented
 * Screenshot/Video toggle · BrowserUrlBar · view-logs wrench; grid-paper
 * stage with the screenshot at its natural aspect ratio, cursor +
 * action-pill overlay, status-bar footer with Hide Cursor. Video mode is
 * UI-ready: renders the pack's video.<ext> or a future result.yaml
 * video_url, else an honest empty state.
 */
export function ScreenshotPanel(_ref2) {
  var _step$effectiveScreen, _packVideo$url, _skin$skin_data, _step$url, _step$ordinal;
  var steps = _ref2.steps,
    selectedKey = _ref2.selectedKey,
    resolution = _ref2.resolution,
    loading = _ref2.loading,
    fullscreen = _ref2.fullscreen,
    videoPath = _ref2.videoPath,
    videoUrl = _ref2.videoUrl,
    skin = _ref2.skin,
    dockOpen = _ref2.dockOpen,
    displayStatus = _ref2.displayStatus,
    onSelect = _ref2.onSelect,
    onToggleLogs = _ref2.onToggleLogs,
    onEnterFullscreen = _ref2.onEnterFullscreen,
    onExitFullscreen = _ref2.onExitFullscreen;
  var index = steps.findIndex(function (s) {
    return s.key === selectedKey;
  });
  var step = index >= 0 ? steps[index] : undefined;
  var _useArtifactUrl = useArtifactUrl((_step$effectiveScreen = step === null || step === void 0 ? void 0 : step.effectiveScreenshotPath) !== null && _step$effectiveScreen !== void 0 ? _step$effectiveScreen : null),
    url = _useArtifactUrl.url,
    state = _useArtifactUrl.state;
  // Pack-internal video streams through the artifact cache (mp4/webm mime).
  var packVideo = useArtifactUrl(videoPath);
  var _useState = useState('screenshot'),
    _useState2 = _slicedToArray(_useState, 2),
    previewMode = _useState2[0],
    setPreviewMode = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    cursorHidden = _useState4[0],
    setCursorHidden = _useState4[1];
  // Keep the previous image + cursor while the next loads — kaneai keeps the
  // component mounted so the cursor CSS-transitions across steps.
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    lastReady = _useState6[0],
    setLastReady = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    lastPoint = _useState8[0],
    setLastPoint = _useState8[1];
  var _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    natural = _useState0[0],
    setNatural = _useState0[1];
  useEffect(function () {
    if (state === 'ready' && url) setLastReady(url);
  }, [state, url]);
  var point = step ? cursorPointFor(step, resolution, natural) : null;
  var rectBox = step ? elementRectFor(step, resolution, natural) : null;
  useEffect(function () {
    if (point) setLastPoint(point);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [point === null || point === void 0 ? void 0 : point.leftPct, point === null || point === void 0 ? void 0 : point.topPct, point === null || point === void 0 ? void 0 : point.label]);
  var shownUrl = state === 'ready' ? url : lastReady;
  var shownPoint = point !== null && point !== void 0 ? point : lastPoint;
  var videoSrc = (_packVideo$url = packVideo.url) !== null && _packVideo$url !== void 0 ? _packVideo$url : videoUrl;
  // kaneai rule (TestCaseSummary): showBrowserBar={!authoringSkin} — a
  // device skin replaces the browser chrome entirely.
  var hasSkin = !!(skin !== null && skin !== void 0 && skin.skin_url) && !!(skin !== null && skin !== void 0 && (_skin$skin_data = skin.skin_data) !== null && _skin$skin_data !== void 0 && _skin$skin_data.width);
  var skinRatios = hasSkin ? getMobileSkinInnerRatios(skin) : null;
  var imageWrapRef = useRef(null);
  var imageRef = useRef(null);
  var getImageElement = useCallback(function () {
    return imageRef.current;
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.panel,
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.toolbar,
      children: [VIDEO_TOGGLE_ENABLED && /*#__PURE__*/_jsx(SegmentedControl, {
        ariaLabel: "Preview mode",
        value: previewMode,
        onChange: function onChange(v) {
          return setPreviewMode(v);
        },
        options: [{
          value: 'screenshot',
          label: 'Screenshot view',
          icon: /*#__PURE__*/_jsx(ScreenshotModeIcon, {})
        }, {
          value: 'video',
          label: 'Video view',
          icon: /*#__PURE__*/_jsx(VideoModeIcon, {})
        }]
      }), /*#__PURE__*/_jsx("div", {
        className: styles.toolbarUrl,
        children: !hasSkin && /*#__PURE__*/_jsx(BrowserUrlBar, {
          url: (_step$url = step === null || step === void 0 ? void 0 : step.url) !== null && _step$url !== void 0 ? _step$url : null
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.toolbarActions,
        children: [/*#__PURE__*/_jsx("button", {
          type: "button",
          className: styles.toolButton,
          "aria-label": dockOpen ? 'Hide Logs' : 'View Logs',
          "aria-pressed": dockOpen,
          onClick: onToggleLogs,
          children: /*#__PURE__*/_jsx(WrenchIcon, {})
        }), /*#__PURE__*/_jsx("button", {
          type: "button",
          className: styles.exitFullscreen,
          "aria-label": fullscreen ? 'Exit fullscreen' : 'Enter fullscreen',
          "aria-pressed": fullscreen,
          onClick: fullscreen ? onExitFullscreen : onEnterFullscreen,
          children: fullscreen ? /*#__PURE__*/_jsx(ScreenNormalIcon, {
            size: 16,
            "aria-hidden": "true"
          }) : /*#__PURE__*/_jsx(ScreenFullIcon, {
            size: 16,
            "aria-hidden": "true"
          })
        })]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "".concat(styles.stage, " ").concat(previewMode === 'screenshot' ? styles.stageGrid : ''),
      children: previewMode === 'video' ? videoSrc ?
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/media-has-caption
      _jsx("video", {
        className: styles.video,
        src: videoSrc,
        controls: true,
        "aria-label": "Test execution video"
      }) : /*#__PURE__*/_jsxs("div", {
        className: styles.emptyState,
        children: [/*#__PURE__*/_jsx(NoVideoIcon, {}), /*#__PURE__*/_jsx("span", {
          className: styles.emptyText,
          children: "No video available"
        })]
      }) : shownUrl && step ? /*#__PURE__*/_jsxs("div", {
        ref: imageWrapRef,
        className: styles.imageWrap,
        style: _objectSpread(_objectSpread({}, natural ? {
          aspectRatio: "".concat(natural.w, " / ").concat(natural.h)
        } : undefined), skinRatios ? {
          maxWidth: "".concat(skinRatios.widthPct, "%"),
          maxHeight: "".concat(skinRatios.heightPct, "%"),
          overflow: 'visible'
        } : undefined),
        children: [/*#__PURE__*/_jsx("img", {
          ref: imageRef,
          className: styles.image,
          src: shownUrl,
          alt: "Screenshot after step ".concat((_step$ordinal = step.ordinal) !== null && _step$ordinal !== void 0 ? _step$ordinal : '', ": ").concat(step.title),
          onLoad: function onLoad(e) {
            var img = e.currentTarget;
            if (img.naturalWidth > 0 && img.naturalHeight > 0) {
              setNatural({
                w: img.naturalWidth,
                h: img.naturalHeight
              });
            }
          }
        }), !cursorHidden && rectBox && /*#__PURE__*/_jsx(ElementRectOverlay, {
          box: rectBox
        }), !cursorHidden && shownPoint && /*#__PURE__*/_jsx(CursorOverlay, {
          point: shownPoint
        }), hasSkin && skin && /*#__PURE__*/_jsx(MobileSkinOverlay, {
          skin: skin,
          getMediaElement: getImageElement,
          wrapperRef: imageWrapRef
        })]
      }) : loading || state === 'loading' ? /*#__PURE__*/_jsx("span", {
        className: styles.stageSkeleton,
        "aria-hidden": "true"
      }) : /*#__PURE__*/_jsxs("div", {
        className: styles.emptyState,
        children: [/*#__PURE__*/_jsx(EmptyStateIcon, {}), /*#__PURE__*/_jsx("span", {
          className: styles.emptyText,
          children: "No screenshot available"
        })]
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.footerRow,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.footerBar,
        children: /*#__PURE__*/_jsx(StatusBar, {
          steps: steps,
          selectedKey: selectedKey,
          displayStatus: displayStatus,
          onSelect: onSelect
        })
      }), /*#__PURE__*/_jsxs("button", {
        type: "button",
        className: styles.hideCursorButton,
        "aria-label": cursorHidden ? 'Show cursor' : 'Hide cursor',
        onClick: function onClick() {
          return setCursorHidden(function (v) {
            return !v;
          });
        },
        children: [/*#__PURE__*/_jsx(CursorButtonIcon, {
          hidden: cursorHidden
        }), /*#__PURE__*/_jsx("span", {
          className: styles.hideCursorText,
          children: cursorHidden ? 'Show Cursor' : 'Hide Cursor'
        })]
      })]
    })]
  });
}